import { render, staticRenderFns } from "./DataExporter.vue?vue&type=template&id=6927ccc5&scoped=true"
import script from "./DataExporter.vue?vue&type=script&lang=js"
export * from "./DataExporter.vue?vue&type=script&lang=js"
import style0 from "./DataExporter.vue?vue&type=style&index=0&id=6927ccc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927ccc5",
  null
  
)

export default component.exports